import React, { useState } from "react";
import md5Hex from "md5-hex";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Api from "../Api/Api.json";
import { useForm } from "react-hook-form";
import MainContainer from "../components/Container/MainContainer";
import FormContainer from "../components/Container/FormContainer";
import FormHeader from "../components/Header/FormHeader";
import TextInput from "../components/Input/TextInput";
import SelectInput from "../components/Input/SelectInput";
import TextArea from "../components/Input/TextArea";
import PasswordInput from "../components/Input/PasswordInput";
import SubmitButton from "../components/Button/SubmitButton";
import Button from "../components/Button/Button";
import FormError from "../components/Error/FormError";

const RegistrationPage2 = () => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    setError: setFormError,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.PATIENT_API;
    const requestData = {
      task: "registerPatient",
      name: data.name,
      age: data.age,
      gender: data.gender,
      email: data.email,
      phone: data.phone,
      address: data.address,
      password: md5Hex(data.password),
      long: 0,
      lat: 0,
      referrer_code: "000",
      device_id: "noid",
    };
    try {
      const response = await axios.post(url, requestData, headers);
      console.log(response);
      if (response.data === 200) {
        alert("Registered");
        navigate("/");
      } else {
        setFormError("root", {
          type: "manual",
          message:
            "Error! Cannot Signup. Make sure you didn't use this number for another account.",
        });
      }
    } catch (error) {
      console.error("Registration error:", error);
      setFormError("root", {
        type: "manual",
        message: "Server error. Please try again later.",
      });
    }
  };

  return (
    <MainContainer
      background="bg-black"
      py="py-12"
      px="px-4"
      sm_px="sm:px-6"
      lg_px="lg:px-8"
      flex="flex"
      main_axis="justify-center"
      cross_axis="items-center"
      flex_direction="flex-row"
    >
      <FormContainer width="max-w-md" spacing="space-y-8">
        <FormHeader
          title="Register to EnergyBand App"
          titleColor="text-white"
        />
        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <div className="rounded-md shadow-sm space-y-4">
            <TextInput
              id="name"
              label="Name"
              placeholder="Enter your name"
              register={register("name", {
                required: "Name is required",
              })}
              errors={errors}
            />
            <TextInput
              id="age"
              label="Age"
              type="number"
              placeholder="Enter your age"
              register={register("age", {
                valueAsNumber: true,
                required: "Age is required",
              })}
              errors={errors}
            />
            <SelectInput
              id="gender"
              label="Gender"
              options={[
                {
                  value: "",
                  label: "Select Gender",
                  disabled: true,
                  selected: true,
                },
                {
                  value: "male",
                  label: "Male",
                  disabled: false,
                  selected: false,
                },
                {
                  value: "female",
                  label: "Female",
                  disabled: false,
                  selected: false,
                },
                {
                  value: "other",
                  label: "Other",
                  disabled: false,
                  selected: false,
                },
              ]}
              register={register("gender", {
                required: "Gender is required",
              })}
              errors={errors}
            />
            <TextInput
              id="phone"
              label="Phone"
              type="tel"
              placeholder="Enter your phone number"
              register={register("phone", {
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Phone number must be numeric",
                },
              })}
              errors={errors}
            />
            <TextInput
              id="email"
              label="Email"
              type="email"
              placeholder="Enter your email"
              register={register("email", {
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Invalid email address",
                },
              })}
              errors={errors}
            />
            <TextArea
              id="address"
              label="Address"
              register={register("address")}
            />
            <PasswordInput
              id="password"
              label="Password"
              placeholder="Enter your password"
              register={register("password", {
                required: "Password is required",
                // minLength: {
                //   value: 6,
                //   message: "Password must be at least 6 characters",
                // },
              })}
              errors={errors}
            />
            <PasswordInput
              id="confirmPassword"
              label="Confirm Password"
              placeholder="Re-enter your password"
              register={register("confirmPassword", {
                required: "Confirm Password is required",
                validate: (value) =>
                  value === watch("password") || "Passwords do not match",
              })}
              errors={errors}
            />
          </div>

          <FormError message={errors.root?.message} />

          <div className="space-y-3">
            <SubmitButton
              disabled={isSubmitting}
              enabledLabel="Submit"
              disabledLabel="Submitting..."
              width="w-full"
              borderColor="border-transparent"
              textColor="text-white"
              backgroundColor="bg-[#58A6FF]"
              hoverBackgroundColor="hover:bg-blue-700"
              focusRingColor="focus:ring-[#58A6FF]"
              disabledOpacity="opacity-50"
            />
            <Button
              type="button"
              onClick={() => navigate("/")}
              label="Back to Login"
              rounded="rounded-md"
              width="w-full"
              borderColor="border-[#30363D]"
              textColor="text-white"
              backgroundColor="bg-[#161B22]"
              hoverBackgroundColor="hover:bg-[#21262D]"
              focusRingColor="focus:ring-[#58A6FF]"
            />
          </div>
        </form>
      </FormContainer>
    </MainContainer>
  );
};

export default RegistrationPage2;
